import type { MaterialData } from '../../project/types/materials';
import {
  getMaterialManufacturerLabel,
  resolveManufacturerLabelFromIds,
} from '../../project/components/dashboard/materials/getMaterialManufacturerLabel';

export function buildManufacturerNameByIdMap(
  manufacturers: Array<Record<string, unknown>>
): Map<number, string> {
  const map = new Map<number, string>();
  for (const m of manufacturers) {
    const id = Number(m.manufacturerId ?? m.manufacturer_id);
    const name = String(m.manufacturerName ?? m.manufacturer_name ?? '').trim();
    if (Number.isFinite(id) && id > 0 && name) {
      map.set(id, name);
    }
  }
  return map;
}

/** Fill missing `manufacturerLabel` from stored manufacturer ids (existing DB rows). */
export function withResolvedManufacturerLabels(
  materials: MaterialData[],
  nameById: Map<number, string>
): MaterialData[] {
  if (!materials.length || nameById.size === 0) return materials;

  return materials.map((material) => {
    const row = material as unknown as Record<string, unknown>;
    if (getMaterialManufacturerLabel(row)) return material;

    const label = resolveManufacturerLabelFromIds(row, nameById);
    if (!label) return material;

    const details = (material.details ?? {}) as Record<string, unknown>;
    const extra = (details.pipeExtraDetails as Record<string, unknown> | undefined) ?? {};

    return {
      ...material,
      details: {
        ...details,
        manufacturerLabel: label,
        pipeExtraDetails: {
          ...extra,
          manufacturerLabel: label,
        },
      },
    };
  });
}
